<template>
  <img
    class="modview__grid-item__icon"
    :class="{ 'modview__grid-item__icon--md-resize': mdResize }"
    :src="item.icon"
    :alt="item.name"
    loading="lazy"
    :title="item.name"
    width="96"
    height="96"
    @error="onError"
  />
</template>

<script lang="ts">
import type { StrapiMinecraftModpack } from '~/apollo/types/types';

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<StrapiMinecraftModpack>,
      required: true,
    },
    mdResize: {
      type: Boolean,
      default: false,
    },
  },
  setup: () => {
    const onError = (event: ErrorEvent) => {
      const image = event.currentTarget as HTMLImageElement;

      image.onerror = null;
      image.src = 'https://cdn.g-portal.com/images/modpack/placeholder.webp';
    };

    return {
      onError,
    };
  },
});
</script>
<style lang="scss" scoped>
@import 'bootstrap/scss/mixins/breakpoints';
@import 'gportal-theme/scss/breakpoints.scss';

.modview__grid-item {
  &__icon {
    width: 6rem;
    height: 6rem;

    &--md-resize {
      @include media-breakpoint-up(md) {
        width: 4rem;
        height: 4rem;
      }

      @include media-breakpoint-up(lg) {
        width: 6rem;
        height: 6rem;
      }
    }
  }
}
</style>
